import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { RestrictionInputSelect } from "./priority/RestrictionInputSelect";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const RestrictionInputItem = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("priority");

  if (config && (config.hidden || config.restriction?.length === 0))
    return <></>;

  const label = t("maintenance:ticket.create.priority.restriction.label");
  return (
    <Form.Item<SaveTicketValues> name="restriction" label={label} {...props}>
      {props.type === "dropdown" ? <RestrictionInputSelect /> : null}
    </Form.Item>
  );
});
